import React from 'react';
import PropTypes from 'prop-types';

// Components
import { MaterialIcon } from '../../../../../components/MaterialIcon';
import { Dialog } from '../../../../../components/Dialog';
import { DialogHeader } from '../../../../../components/DialogHeader';
import { DialogBody } from '../../../../../components/DialogBody';
import { DialogFooter } from '../../../../../components/DialogFooter';
import { Button } from '../../../../../components/Button';
import FeedbackCard from '../../../../../components/FeedbackCard';

export const DeleteResourceParam = ({ data, closeDialog, onDelete, sessionToken }) => {
    const [wasSuccessful, setWasSuccessful] = React.useState(false);
    const [fatalError, setFatalError] = React.useState(null);
    const [deleteData, setDeleteData] = React.useState();

    React.useEffect(() => {
        if (!deleteData) {
            setDeleteData(data);
        }
    }, [data]);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Delete = () => {
        onDelete(data);
        CloseDialog();
    };

    return (
        <Dialog close={CloseDialog} size="md" visible id="criteria-resource-param-manager-delete">
            <DialogHeader close={CloseDialog}>{`Delete ${deleteData?.name}`}</DialogHeader>
            <DialogBody>
                Are you sure you wish to delete this parameter?
                {fatalError != null && (
                    <FeedbackCard
                        intent={'danger'}
                        feedback={{
                            heading: `An error has occurred.`,
                            message: `Please wait a few moments before trying your request
        again.`
                        }}
                        details={fatalError}
                    />
                )}
            </DialogBody>
            <DialogFooter>
                {wasSuccessful && (
                    <div style={{ marginRight: '0.5rem' }}>
                        <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                    </div>
                )}
                <Button appearance="primary" text onClick={Delete}>
                    Delete
                </Button>
                <Button appearance="secondary" text onClick={CloseDialog}>
                    Cancel
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

DeleteResourceParam.propTypes = {
    sessionToken: PropTypes.string.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default DeleteResourceParam;
